import React from "react"
import { Navigate } from "react-router-dom"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Chat
import Chat from "../pages/Chat/index"
import QueueView from "../pages/Chat/Queue/QueueView"
import TicketList from "../pages/Chat/Tickets/TicketList"

import AllBookings from "../pages/AllBookings/allBookings"

import AddNewBooking from "../pages/AddNewBooking/addNewBooking"

import WorldPayNotify from "../pages/WorldPay/worldpay-notify"
import WorldPayResponse from "../pages/WorldPay/worldpay-response"
import WorldPayCancel from "../pages/WorldPay/worldpay-cancel"

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  { path: "/allbookings", component: <AllBookings /> },

  { path: "/add-new-booking", component: <AddNewBooking /> },

  { path: "/chat", component: <Chat /> },
  { path: "/chat/queue", component: <QueueView /> },
  { path: "/chat/tickets", component: <TicketList /> },

  { path: "/worldpay-notify", component: <WorldPayNotify /> },
  { path: "/worldpay-response", component: <WorldPayResponse /> },
  { path: "/worldpay-cancel", component: <WorldPayCancel /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/allbookings" />,
  },
  { path: "*", component: <Navigate to="/allbookings" /> },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
]

export { userRoutes, authRoutes }
